import React from 'react';

const Card = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={`rounded-xl border bg-card text-card-foreground shadow ${className}`}
    {...props}
  />
));
Card.displayName = 'Card';

const CardHeader = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={`flex flex-col space-y-1.5 p-6 ${className}`}
    {...props}
  />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={`font-semibold leading-none tracking-tight ${className}`}
    {...props}
  />
));
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={`text-sm text-muted-foreground ${className}`}
    {...props}
  />
));
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef(({ className = '', ...props }, ref) => (
  <div ref={ref} className={`p-6 pt-0 ${className}`} {...props} />
));
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    className={`flex items-center p-6 pt-0 ${className}`}
    {...props}
  />
));
CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };


// import React from 'react';
// import './Card.css'; // Normal CSS

// const Card = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card ${className}`} {...props} />
// ));
// Card.displayName = 'Card';

// const CardHeader = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card-header ${className}`} {...props} />
// ));
// CardHeader.displayName = 'CardHeader';

// const CardTitle = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card-title ${className}`} {...props} />
// ));
// CardTitle.displayName = 'CardTitle';

// const CardDescription = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card-description ${className}`} {...props} />
// ));
// CardDescription.displayName = 'CardDescription';

// const CardContent = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card-content ${className}`} {...props} />
// ));
// CardContent.displayName = 'CardContent';

// const CardFooter = React.forwardRef(({ className = '', ...props }, ref) => (
//   <div ref={ref} className={`card-footer ${className}`} {...props} />
// ));
// CardFooter.displayName = 'CardFooter';

// export { Card, CardHeader, CardFooter, CardTitle, CardDescription, CardContent };
